<template>
  <material-card
    :title="`${ $t('History') }`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs4
            md4>
            <MaglinkComponentTankList
              :loading="progessBar.loading"
              :filters="filters"
              :tanks="tanks" />
          </v-flex>
          <!--
          <v-flex
            xs2
            md2>
            <v-switch
              :disabled="progessBar.loading"
              v-model="filters.all"
              :label="`${ $t('All tanks') }`"
              class="dover-input"/>
          </v-flex>
          -->
          <v-flex
            xs2
            md2>
            <MaglinkComponentDatePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(1)"
              :date-label="getDateLabel('For')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="false"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs3
            md3
            text-xs-left>
            <v-btn-toggle
              v-model="showGraph"
              dense
              group
              mandatory
              @change="onChangeType(0)">
              <v-btn
                key="0"
                value="0"
                text
                small
                color="dover-blue">
                {{ $t('Table') }}
              </v-btn>
              <v-btn
                key="1"
                value="1"
                text
                small
                color="dover-blue">
                {{ $t('Graph') }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs3
            md3
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || progessBar.loading"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyFilter">
              {{ $t('Filter') }}
            </v-btn>
            <MaglinkComponentCsvExportButton
              :is-validation-ok="isValidationOk"
              :loading="progessBar.loading"
              @csvExport="csvExport" />
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <MaglinkComponentLoadingBar
              :loading="progessBar.loading"
              :indeterminate="false"
              :max-value="progessBar.maxValue"
              :value="progessBar.currentValue" />
            <MaglinkComponentGraphFilter
              :key="dataSelectionKey"
              :show-component="showGraph === '1'"
              :show-refresh-button="true"
              :data-selection="dataSelection"
              :data-config="graphConfig"
              :item-count-label="itemCountLabel"
              :refresh-label="$t('Refresh')"
              @onRefresh="onDataSelectionRefresh"/>
            <v-flex
              v-show="showGraph === '1'"
              xs12
              md12
              lg12
              text-xs-center>
              <apexchart
                :options="lineChart.options"
                :series="lineChart.options.series"
                height= "450"
                width= "100%"
                type= "line" />
            </v-flex>
            <v-flex
              v-show="showGraph === '0'"
              xs12
              md12
              lg12
              fill-height>
              <v-data-table
                :headers="headers"
                :items="tableSource"
                :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                :no-results-text="`${ Maglink.NoDataMessage(true) }`"
                hide-actions>
                <template
                  slot="headerCell"
                  slot-scope="{ header }">
                  <span
                    class="dover-light-blue-color"
                    v-text="header.text" />
                </template>
                <template
                  slot="items"
                  slot-scope="{ index, item }">
                  <tr
                    :style="{backgroundColor: ((index % 2 === 0) ? '#cfdbfb' : 'transparent' ) }"
                    class="text-xs-left">
                    <td>{{ Maglink.GetCustomDateTime(item.measuredOn, systemSettings.dateFormat).substr(0, 16) }}</td>
                    <td class="text-xs-right">{{ item.tankNumber }}</td>
                    <td class="text-xs-right">{{ item.productLevel }}</td>
                    <td class="text-xs-right">{{ item.waterLevel }}</td>
                    <td class="text-xs-right">{{ Maglink.TemperatureFormat(Maglink.TemperatureToDisplay(item.temperature, systemSettings.temperatureUnit)) }}</td>
                    <td class="text-xs-right">{{ item.productVolume }}</td>
                    <td class="text-xs-right">{{ item.productVolumeComp }}</td>
                    <td class="text-xs-right">{{ item.waterVolume }}</td>
                    <td class="text-xs-right">{{ Maglink.DensityFormat(item.density) }}</td>
                    <td class="text-xs-center">{{ Maglink.GetStatusInfo(item.tankStatus).statusDesc }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
        </v-flex></v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>

import Vue from 'vue'

export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    mustRefreshGraph: false,
    mustRefreshTable: false,
    dataSelection: [ [0, 1, 3], [], [], [] ],
    dataSelectionIndex: 0,
    graphConfig: [],
    lineChart: {
      options: {
        chart: { },
        series: [],
        dataLabels: { },
        stroke: { },
        xaxis: {},
        tooltip: { },
        title: { },
        yaxis: [ ]
      }
    },
    datePickerKey: 1,
    dataSelectionKey: 1,
    progessBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    isValidationOk: false,
    itemCountLabel: '',
    headers: [],
    rules: {
      isDate: [ v => true ]
    },
    levelUdm: '',
    volUdm: '',
    densityUdm: '',
    tempUdm: '',
    showGraph: '2',
    tableSource: [],
    rawDataSource: [],
    filters: {
      all: false,
      number: 1,
      fromDay: '',
      fromDayDate: new Date()
    }
  }),
  mounted () {
    this.filters.fromDayDate = new Date()
    this.filters.fromDay = this.Maglink.GetCustomDate(this.filters.fromDayDate, 'yyyy-MM-dd')

    this.levelUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    this.densityUdm = 'Kg/m3'
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc
    this.headers = [
      { sortable: false, text: this.$t('Time'), align: 'center' },
      { sortable: false, text: this.$t('Tank'), align: 'right' },
      { sortable: false, text: this.$t('Level ({0})', [this.levelUdm]), align: 'right' },
      { sortable: false, text: this.$t('Water ({0})', [this.levelUdm]), align: 'right' },
      { sortable: false, text: this.$t('Temp ({0})', [this.tempUdm]), align: 'right' },
      { sortable: false, text: this.$t('Volume ({0})', [this.volUdm]), align: 'right' },
      { sortable: false, text: this.$t('TC volume ({0})', [this.volUdm]), align: 'right' },
      { sortable: false, text: this.$t('Water vol ({0})', [this.volUdm]), align: 'right' },
      { sortable: false, text: this.$t('Density ({0})', [this.densityUdm]), align: 'right' },
      { sortable: false, text: this.$t('Status'), align: 'center' }
    ]
    this.loadGraphConfig()
  },
  methods: {
    loadGraphConfig () {
      let volUnitIndex = this.systemSettings.volumeUnit
      let levelUnitIndex = this.systemSettings.levelUnit

      this.graphConfig = [
        {
          index: 0,
          desc: this.$t('Volume'),
          key: 'productVolume',
          group: 'vol',
          opposite: false,
          seriesName: 'volume',
          yValue: [],
          yTooltipTitle: this.$t('Volume ({0})', [ this.volUdm ]),
          yTitle: this.volUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 1,
          desc: this.$t('TC Volume'),
          key: 'productVolumeComp',
          group: 'vol',
          opposite: false,
          seriesName: 'TCvolume',
          yValue: [],
          yTooltipTitle: this.$t('TC Volume ({0})', [ this.volUdm ]),
          yTitle: this.volUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 2,
          desc: this.$t('Water'),
          key: 'waterVolume',
          group: 'Wvol',
          opposite: false,
          seriesName: 'waterVolume',
          yValue: [],
          yTooltipTitle: this.$t('Water ({0})', [ this.volUdm ]),
          yTitle: this.volUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 3,
          desc: this.$t('Temperature'),
          key: 'temperature',
          group: 'vol',
          opposite: true,
          seriesName: 'temperature',
          yValue: [],
          yTooltipTitle: this.$t('Temperature ({0})', [ this.tempUdm ]),
          yTitle: this.tempUdm,
          formatter: function (list) {
            return list
          }
        },
        {
          index: 4,
          desc: this.$t('Product'),
          key: 'productLevel',
          group: 'level',
          opposite: false,
          seriesName: 'productLevel',
          yValue: [],
          yTooltipTitle: this.$t('Product ({0})', [ this.levelUdm ]),
          yTitle: this.levelUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.LevelToDisplay(list[index], levelUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 5,
          desc: this.$t('Water'),
          key: 'waterLevel',
          group: 'level',
          opposite: false,
          seriesName: 'waterLevel',
          yValue: [],
          yTooltipTitle: this.$t('Water ({0})', [ this.levelUdm ]),
          yTitle: this.levelUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.LevelToDisplay(list[index], levelUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 6,
          desc: this.$t('Density'),
          key: 'density',
          group: 'den',
          opposite: false,
          seriesName: 'density',
          yValue: [],
          yTooltipTitle: this.$t('Density ({0})', [ 'Kg/m3' ]),
          yTitle: 'Kg/m3',
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 7,
          desc: this.$t('TC Density'),
          key: 'densityComp',
          group: 'den',
          opposite: false,
          seriesName: 'TCdensity',
          yValue: [],
          yTooltipTitle: this.$t('TC Density ({0})', [ 'Kg/m3' ]),
          yTitle: 'Kg/m3',
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        }
      ]

      // IMPORTANT TO FORCE REFRESH
      this.dataSelectionKey += 1
    },
    onDataFilter (currIndex) {
      this.dataSelectionIndex = currIndex

      // clear other selection
      for (let index = 0; index < this.dataSelection.length; index++) {
        if (index === currIndex) continue
        this.dataSelection[index] = []
      }
    },
    onDataSelectionRefresh (dataSelection, dataSelectionIndex) {
      this.dataSelectionIndex = dataSelectionIndex
      this.dataSelection = dataSelection

      this.fillGraph()
    },
    onChangeType () {
      if (this.showGraph === 1) {
        if (this.mustRefreshGraph) {
          this.fillGraph()
        }
      } else {
        if (this.mustRefreshTable) {
          this.fillTable()
        }
      }
    },
    applyFilter () {
      this.getDataSource()
    },
    getDataSource () {
      this.tableSource = []
      this.rawDataSource = []

      let dt = new Date(this.filters.fromDay)
      this.filters.fromDay = this.Maglink.GetCustomDate(this.Maglink.GetLocalToUtcTime(dt.getTime()).date, 'yyyy-MM-dd')

      // RESULT IS ORDERED BY DATE DESC
      this.Maglink.GetReportHistory(this.filters)
        .then(response => {
          this.rawDataSource = response.data
          this.mustRefreshGraph = true
          this.mustRefreshTable = true

          // firt time
          if (this.showGraph === '2') {
            this.showGraph = '1'
          }

          if (this.showGraph === '0') {
            this.fillTable()
          } else {
            this.fillGraph()
          }
        })
        .catch(error => {
          this.progessBar.loading = false
          this.snack('error', error.message)
        })
    },
    fillTable () {
      this.progessBar.loading = true
      let total = this.rawDataSource.length
      this.progessBar.maxValue = total

      for (let i = 0; i < total; i++) {
        let item = this.rawDataSource[i]

        this.progessBar.currentValue = i
        this.tableSource.push(this.Maglink.ToDisplay(item, this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
      }

      // GUI management
      this.progessBar.loading = false
      this.itemCountLabel = this.$t('Items: {0}', [ total ])
      this.mustRefreshTable = false
    },
    fillGraph () {
      this.progessBar.loading = true
      // put in cronological order
      let source = this.rawDataSource.map(a => a).reverse()
      let total = source.length
      this.progessBar.maxValue = total

      // x-axis
      let xValues = source.map(a => a.measuredOn * 1000)

      for (let count = 0; count < xValues.length - 1; count++) {
        xValues[count] = this.Maglink.GetUtcToLocalTime(xValues[count]).number
      }

      let series = []
      let yAxis = []
      let columnDesc = []

      // column selected
      let selection = this.dataSelection[this.dataSelectionIndex]
      for (let index = 0; index < selection.length; index++) {
        // current column index
        let itemIndex = selection[index]
        // current column config
        let currConfig = this.graphConfig[itemIndex]

        columnDesc.push(currConfig.desc)
        // get y values
        currConfig.yValue = currConfig.formatter(source.map(a => a[currConfig.key]))
        series.push({
          name: currConfig.yTooltipTitle,
          type: 'line',
          data: currConfig.yValue
        })

        yAxis.push(
          {
            seriesName: currConfig.seriesName,
            opposite: currConfig.opposite,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#00E396'
            },
            labels: {
              style: {
                colors: '#00E396'
              }
            },
            title: {
              text: currConfig.yTitle,
              style: {
                color: '#00E396'
              }
            }
          }
        )
      }

      // let xLabel = this.$t('Time') + ': '
      /*   let reportTitle = this.$t('History report') + ': '
      reportTitle += this.filters.all ? '' : this.tanks[this.filters.number - 1].tankDescription
      reportTitle += ' - ' + this.Maglink.GetCustomDate(this.filters.fromDayDate, this.systemSettings.dateFormat)
      reportTitle += ' (' + columnDesc.join(',') + ')'
*/
      this.lineChart = {
        options: {
          chart: {
            height: 350,
            type: 'line',
            stacked: false
          },
          dataLabels: {
            enabled: false
          },
          colors: ['#FF1654', '#247BA0'],
          series: [
            {
              name: 'Series A',
              data: [1111.4, 1112, 1112.5, 1111.5, 1112.5, 1112.8, 1113.8, 1114.6]
            },
            {
              name: 'Series B',
              data: [20, 29, 37, 36, 44, 45, 50, 58]
            }
          ],
          stroke: {
            width: [4, 4]
          },
          plotOptions: {
            bar: {
              columnWidth: '20%'
            }
          },
          xaxis: {
            categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016]
          },
          yaxis: [
            {
              forceNiceScale: false,
              min: 950,
              axisTicks: {
                show: true
              },
              axisBorder: {
                show: true,
                color: '#FF1654'
              },
              labels: {
                style: {
                  colors: '#FF1654'
                }
              },
              title: {
                text: 'Series A',
                style: {
                  color: '#FF1654'
                }
              }
            },
            {
              opposite: true,
              axisTicks: {
                show: true
              },
              axisBorder: {
                show: true,
                color: '#247BA0'
              },
              labels: {
                style: {
                  colors: '#247BA0'
                }
              },
              title: {
                text: 'Series B',
                style: {
                  color: '#247BA0'
                }
              }
            }
          ],
          tooltip: {
            shared: false,
            intersect: true,
            x: {
              show: false
            }
          },
          legend: {
            horizontalAlign: 'left',
            offsetX: 40
          }
        }
      }
      /*
      this.lineChart = {
        series: series,
        options: {
          chart: {
            height: 350,
            type: 'line',
            stacked: false
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: [1, 1, 4]
          },
          xaxis: {
            type: 'datetime',
            categories: xValues,
            title: {
              text: ''
            }
          },
          tooltip: {
            x: {
              formatter: function (val) {
                let dt = new Date(val)
                return xLabel + dt.toISOString().substr(11, 5)
              }
            }
          },
          title: {
            text: reportTitle,
            align: 'center'
          },
          yaxis: yAxis
        }
      }
*/

      /*
      this.chartOptions = {...this.chartOptions, ...{
    xaxis: {
        labels: {
           style: {
             colors: ['red']
           }
        }
    }
}}
      */

      this.progessBar.loading = false
      this.itemCountLabel = this.$t('Items: {0}', [ total ])
      this.mustRefreshGraph = false
    },
    csvExport (sep) {
      let fileContent = ''
      let title = ''
      // filter
      if (this.filters.all) {
        title = this.$t('All tanks')
        fileContent += title + '\n'
      } else {
        title = this.$t('Tank {0}', [ this.filters.number ])
        fileContent += title + sep
        fileContent += this.tanks[this.filters.number - 1].tankDescription + '\n'
      }
      fileContent += this.$t('Date') + sep
      fileContent += (this.filters.fromDay !== undefined ? this.filters.fromDay : '') + '\n'
      fileContent += '\n'

      for (let index = 0; index < this.headers.length; index++) {
        fileContent += this.headers[index].text + sep
      }
      fileContent += '\n'

      for (let index = 0; index < this.tableSource.length; index++) {
        let t = this.tableSource[index]
        fileContent += this.Maglink.GetCustomDateTime(t.measuredOn, this.systemSettings.dateFormat).substr(0, 16) + sep
        fileContent += t.tankNumber + sep
        fileContent += t.productLevel + sep
        fileContent += t.waterLevel + sep
        fileContent += this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(t.temperature, this.systemSettings.temperatureUnit)) + sep
        fileContent += t.productVolume + sep
        fileContent += t.productVolumeComp + sep
        fileContent += t.waterVolume + sep
        fileContent += this.Maglink.DensityFormat(t.density) + sep
        fileContent += this.Maglink.GetStatusInfo(t.tankStatus).statusDesc + '\n'
      }

      /*
      const url = window.URL.createObjectURL(new Blob([fileContent], { type: 'application/vnd.ms-excel' }))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', 'Detail_Blast.xls')
      document.body.appendChild(link)
      link.click()
      */
      let filename = this.$t('History report') + '__' + title
      filename += '__' + (this.filters.fromDay !== undefined ? this.filters.fromDay : '')
      filename += '.csv'
      const link = this.Maglink.GetDownloadLinkCSV(fileContent, filename)
      document.body.appendChild(link)
      link.click()
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    onDayChange (days) {
      let currentDate = this.filters.fromDayDate
      currentDate.setDate(currentDate.getDate() + days)
      this.filters.fromDayDate = currentDate
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.$t(this.systemSettings.dateFormat) + ')'
    },
    onCheckDates () {
      return true
    },
    onGetDate (componentKey, day) {
      this.filters.fromDay = day
      this.filters.fromDayDate = new Date(day + 'T00:00')
    },
    snack (color, message) {
      message = this.$t('History') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
<!--
<style>
  #chart {
    max-width: 650px;
    margin: 35px auto;
  }

  .toolbar {
    margin-left: 45px;
  }

  button {
    background: #fff;
    color: #222;
    border: 1px solid #e7e7e7;
    border-bottom: 2px solid #ddd;
    border-radius: 2px;
    padding: 4px 17px;
  }

  button.active {
    color: #fff;
    background: #008FFB;
    border: 1px solid blue;
    border-bottom: 2px solid blue;
  }

  button:focus {
    outline: 0;
  }
</style>
-->
